import { UploadFileModel } from '../../../shared/data/models/upload-file.model';
import { FileUploadModel } from '../../../shared/file-upload.model';

export interface PostFormState {
  formType: 'POST' | 'POLL' | 'ARTICLE';
  showTitle: boolean;
  showBody: boolean;
  showArticleBody: boolean;
  showPoll: boolean;
  allowUpload: boolean;
  uploadFiles: UploadFileModel[];
  uploadVideos: FileUploadModel[];
}

export const initialPostFormState: PostFormState = {
  formType: 'POST',
  showBody: true,
  showTitle: false,
  showPoll: false,
  showArticleBody: false,
  allowUpload: true,
  uploadFiles: [],
  uploadVideos: []
};
